<template>
	<div class="confirm-popup">
		<div class="confirm-wr">
			<button class="confirm__close" @click="isPopupOpen = false">
				<Cross />
			</button>
			<div v-if="!isCanceled">
				<h2>Вы действительно хотите отменить запись?</h2>
				<div class="confirm__btns">
					<button @click="handleCancelOrder">Да, отменить</button>
					<button @click="isPopupOpen = false">Нет, не отменять</button>
				</div>
			</div>
			<div v-else>
				<h2>Ваша запись успешно отменена</h2>
				<div class="confirm__btns">
					<button @click="isPopupOpen = false">Ок</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
import { computed, ref } from "vue";
import Cross from "./Icons/Cross.vue";
import { useApi } from "@/composables/useApi";

const { cancelOrder } = useApi();

const isCanceled = ref(false);

const isPopupOpen = defineModel();

const session_id = computed(() => {
	const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('session_id');
});

const event_id = computed(() => {
	const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('event_id');
});

const handleCancelOrder = async () => {
	try {
		await cancelOrder(session_id.value, event_id.value);
		isCanceled.value = true;
	} catch (e) {
		console.error(e);
		isPopupOpen.value = false;
	}
}
</script>
<style lang='scss'>
.confirm__close {
	position: absolute;
	right: 24px;
}

.confirm-popup {
	width: 100vw;
	height: 100vh;
	padding-inline: 32px;
	position: fixed;
	display: grid;
	place-items: center;
	background-color: rgba($color: #000000, $alpha: .4);
}

.confirm-wr {
	width: 100%;
	max-width: 540px;
	height: auto;
	padding: 24px 42px;
	position: relative;
	border-radius: 20px;
	background-color: #FFF;

	h2 {
		font-size: 32px;
		line-height: 1;
		text-align: center;
	}

	@media (max-width: 768px) {
		h2 { font-size: 24px }
	}

	@media (max-width: 480px) {
		h2 { font-size: 16px }
	}
}

.confirm__btns {
	margin-top: 24px;
	width: 100%;
	display: flex;
	gap: 12px;

	button {
		width: 100%;
		height: 48px;
		border-radius: 8px;
		font-size: 18px;
		font-weight: 700;
	}

	button:first-child {
		background-color: $yellow;
		color: #FFF;
	}

	button:nth-child(2) { background-color: #EFEFEF }

	@media (max-width: 768px) {
		button { font-size: 16px }
	}

	@media (max-width: 480px) {
		button {
			height: 30px;
			font-size: 10px;
		}
	}
}
</style>